import type { IAddress } from '@/types/address';
import type { CV } from '@/types/worker';

export enum InputMode {
	DROPDOWN = 'dropdown',
	TEXT = 'text',
}

export interface LoadedCompany {
	id: string;
	name: string;
	slug: string;
	address: IAddress;
	businessSector: string | null;
	collaborator: string | null;
	contact: string;
	phone: string;
	email: string;
	website: string | null;
	lastMission: string | null;
	createdAt: string;
}

export interface LoadedWorker {
	id: string;
	firstname: string;
	lastname: string;
	jobNames: { id: string; name: string }[];
	manager: string;
	phone: string;
	email: string;
	city: string;
	vehicle: boolean;
	weekendShift: boolean;
	nightShift: boolean;
	status: string;
	geolocated: boolean;
	inactiveByAgencies: string;
	askedChanges: string;
	agenciesList: string[];
	createdAt: number;
	picture: string;
	collection?: string;
	cv?: CV;
	anonymizedCv?: CV;
	companiesBlacklist: string[];
}
